import { Icon, Stepper, PrimaryButton, Header, useAppLayout } from '@artprov/design-system'
import { useOnboarding } from './onboarding.hook'
import { Show } from '../../common/components/Show'
import { VerificarEmailSection } from './verificar-email/verificar-email.component'
import { VerificarCodigoSection } from './verificar-codigo/verificar-codigo.component'
import { NuevaContrasenaSection } from './nueva-contrasena/nueva-contrasena.component'
import { DatosPersonalesSection } from './datos-personales/datos-personales.component'
import { StepId } from './lib/utils'
import { useEffect, useState } from 'react'

export function OnboardingPage() {
  const { steps, currentStep, completed, isVerifying } = useOnboarding()
  const { setShowHeader } = useAppLayout()

  const [redirectTimer, setRedirectTimer] = useState(10)

  // Al ser `/onboarding` una ruta pública (fuera de <ProtectedLayout>), el
  // `AppRouter` del design-system renderiza su Header global y esta página
  // también renderiza el suyo, duplicándose. Se oculta el global mientras la
  // página está montada y se restaura al desmontarse.
  useEffect(() => {
    setShowHeader(false)
    return () => setShowHeader(true)
  }, [setShowHeader])

  useEffect(() => {
    if (completed) {
      // const timer = setTimeout(() => {
      //   setRedirectTimer((prev) => prev - 1)
      // }, 1000)
      // if (redirectTimer === 0) {
      //   redirectToLogin()
      // }
      // return () => clearTimeout(timer)
    }
  }, [redirectTimer, completed])

  const redirectToLogin = () => {
    window.location.href = import.meta.env.VITE_WEB_URL ?? window.location.origin
  }
  if (isVerifying) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Icon size="extra-large" variant="loading" />
      </div>
    )
  }

  return (
    <>
      <Header showDropdown={false} showNotifications={false} className="shadow-md" />
      <section className="flex flex-col gap-8 items-center justify-center py-8 font-f1 lg:px-24 xl:px-36 w-full">
        <Show when={!completed}>
          <header className="w-full flex flex-col items-center gap-2 px-4 md:px-0">
            <h1 className="text-[24px] font-semibold sp text-primary-20 tracking-0.15">
              Te damos la bienvenida a la nueva web de presentación de DDJJ No SUSS
            </h1>
            <p className="text-14 tracking-[0.25px]">Completá estos simples pasos para ingresar a la plataforma.</p>
          </header>

          <div className="w-full lg:px-48 md:px-8 px-4">
            <Stepper steps={steps} />
          </div>

          <div className="w-full lg:px-48 md:px-8 px-4">
            <Show when={currentStep === StepId.VERIFY_EMAIL}>
              <VerificarEmailSection />
            </Show>

            <Show when={currentStep === StepId.VERIFICATION_CODE}>
              <VerificarCodigoSection />
            </Show>

            <Show when={currentStep === StepId.NEW_PASSWORD}>
              <NuevaContrasenaSection />
            </Show>

            <Show when={currentStep === StepId.DATOS_PERSONALES}>
              <DatosPersonalesSection />
            </Show>
          </div>
        </Show>

        <Show when={completed}>
          <div className="flex flex-col items-center justify-center gap-4">
            <Icon icon="check_circle" className="py-4" classNameIcon="text-success-10" size="extra-large" />
            <h1 className="text-[24px] font-semibold sp text-primary-20 tracking-0.15">Te registraste con éxito</h1>
            <div className="text-center text-gray-700 text-sm leading-relaxed space-y-2">
              <p className="text-15 mb-5">A partir de ahora, para gestionar tus trámites:</p>

              <ul className="list-disc list-inside space-y-1 subtitle1">
                <li>
                  Ingresá con el <span className="font-semibold">mail</span> y la
                  <span className="font-semibold"> contraseña</span> que acabás de crear.
                </li>
                <li>
                  Accedé desde este nuevo enlace: www.organismos-publicos.artprovincia.ar
                  <br />
                  <p className="text-15 subtitle1 ">Te recomendamos guardarlo en favoritos.</p>
                </li>
              </ul>
            </div>
            <PrimaryButton
              onClick={() => {
                redirectToLogin()
              }}
            >
              Ingresar
            </PrimaryButton>
          </div>
        </Show>
      </section>
    </>
  )
}
